/**
 * 文件说明：列表节点单个 slot 的引用连接按钮。
 *
 * 具体点击/拖拽逻辑统一交给 useSlotReferenceLinkInteraction，避免单 slot
 * 和批量 slot 快速连接出现两套行为。
 */
import { useCallback } from 'react'
import { useSlotReferenceLinkInteraction } from '../lib'
import QuickLink from '@/assets/images/ic_quick_link.svg'
import { Tip } from "@/shared/components/ui/tooltip";

export interface SlotLinkButtonProps {
  sourceNodeId: string
  sourceKind: 'image' | 'text' | 'video' | 'audio'
  slotIndex: number
  className?: string
}

/**
 * 渲染一个单 slot 引用连接按钮。
 *
 * @param sourceNodeId 当前列表节点 ID
 * @param sourceKind 当前 slot 对外表现的单项 source 类型
 * @param slotIndex 当前批次内 slot 下标
 * @param className 附加样式，通常由具体列表 item 决定定位
 */
export function SlotLinkButton({
  className,
  sourceKind,
  slotIndex,
  sourceNodeId,
}: SlotLinkButtonProps) {
  const getSlotIndexes = useCallback(() => [slotIndex], [slotIndex])
  const linkInteraction = useSlotReferenceLinkInteraction({
    getSlotIndexes,
    sourceKind,
    sourceNodeId,
  })

  return (
    <Tip content={"引用此格"} delayDuration={0}>
      <button
            type="button"
            aria-label="引用此格"
            className={`!cursor-crosshair ${className ?? ''}`}
            {...linkInteraction}
          >
            <img
              alt="快速连接"
              className="h-4 w-4"
              draggable={false}
              src={QuickLink}
              onDragStart={linkInteraction.onDragStart}
            />
          </button>
      </Tip>
  )
}
